/* Carbon Edge launch theme */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smoothstep = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  const rng = seed => { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; };
  const RM = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- split text, once ---------- */
  function splitEl(el, mode, rand, spread) {
    const text = el.textContent.trim();
    const sr = document.createElement('span');
    sr.className = 'sr';
    sr.textContent = text;
    const vis = document.createElement('span');
    vis.setAttribute('aria-hidden', 'true');
    const words = text.split(' ');
    const total = text.replace(/ /g, '').length;
    let ci = 0;
    words.forEach((word, wi) => {
      const w = document.createElement('span');
      w.className = 'w';
      if (mode === 'rise') w.style.setProperty('--th', (wi / words.length * 0.5).toFixed(3));
      if (mode === 'scatter' || mode === 'snap') {
        [...word].forEach(ch => {
          const c = document.createElement('span');
          c.className = 'c';
          c.textContent = ch;
          if (mode === 'scatter') {
            c.style.setProperty('--th', (rand() * spread).toFixed(3));
            c.style.setProperty('--jx', ((rand() - 0.5) * 120).toFixed(1) + 'px');
            c.style.setProperty('--jy', ((rand() - 0.5) * 80).toFixed(1) + 'px');
            c.style.setProperty('--jr', ((rand() - 0.5) * 50).toFixed(1) + 'deg');
          } else {
            c.style.setProperty('--th', (ci / total * spread + rand() * 0.06).toFixed(3));
            c.style.setProperty('--jx', (-40 - rand() * 30).toFixed(1) + 'px');
          }
          ci++;
          w.appendChild(c);
        });
      } else {
        w.textContent = word;
      }
      vis.appendChild(w);
      if (wi < words.length - 1) vis.appendChild(document.createTextNode(' '));
    });
    el.textContent = '';
    el.append(sr, vis);
  }

  function splitBlur(el) {
    const text = el.textContent.trim();
    el.innerHTML = '';
    const sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = text;
    const sharp = document.createElement('span'); sharp.className = 'sharp'; sharp.setAttribute('aria-hidden', 'true'); sharp.textContent = text;
    const soft = document.createElement('span'); soft.className = 'soft'; soft.setAttribute('aria-hidden', 'true'); soft.textContent = text;
    el.append(sr, sharp, soft);
  }

  const bands = $$('.band').map((el, i) => {
    const [a, b] = el.dataset.range.split(',').map(Number);
    const fx = el.dataset.fx;
    const rand = rng(1009 + i * 7919);
    const spread = Number(el.dataset.spread || 0.5);
    $$('.split', el).forEach(s => fx === 'blur' ? splitBlur(s) : splitEl(s, fx, rand, spread));
    return { el, a, b, fx, ramp: Number(el.dataset.ramp || 0), op: -1, k: -1, ks: -1, kb: -1, first: i === 0, last: false };
  });
  if (bands.length) bands[bands.length - 1].last = true;

  /* ---------- hero ---------- */
  const hero = $('.hero');
  const stage = $('.hero__pin');
  const video = $('.hero__video');
  const posterImg = $('.poster__watch');
  const ring = $('.ring');
  const sweepHost = $('.hero__stage');
  const VIDEO_URL = hero ? hero.dataset.video : '';
  const VIDEO_BYTES = hero ? Number(hero.dataset.bytes) || 6000000 : 0;

  let target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = true;
  let loadK = 0, loadStart = 0;
  let lastSw = -1, lastLit = -1, scrolledOn = null;

  function heroProgress() {
    if (!hero) return 0;
    const r = hero.getBoundingClientRect();
    const range = r.height - innerHeight;
    return range > 0 ? clamp(-r.top / range, 0, 1) : 0;
  }

  function updateCaptions(p, now) {
    if (!loadStart) loadStart = now || performance.now();
    loadK = clamp(((now || performance.now()) - loadStart) / 1400, 0, 1);
    loadK = 1 - Math.pow(1 - loadK, 3);
    for (const bd of bands) {
      const { a, b } = bd;
      const f = Math.min(0.02, (b - a) / 3);
      const inA = bd.first ? 1 : smoothstep(p, a, a + f);
      const outB = bd.last ? 1 : 1 - smoothstep(p, b - f, b);
      const op = inA * outB;
      const ramp = bd.ramp || Math.min(0.025, (b - a) * 0.35);
      let k = clamp((p - a) / ramp, 0, 1);
      if (bd.first) k = Math.max(k, loadK);
      if (bd.last && p >= 0.999) k = 1;
      if (Math.abs(op - bd.op) > 0.004 || (op === 0) !== (bd.op === 0) || (op === 1) !== (bd.op === 1)) {
        bd.op = op;
        bd.el.style.opacity = op.toFixed(3);
        bd.el.classList.toggle('on', op > 0.5);
      }
      if (Math.abs(k - bd.k) > 0.008 || (k === 1 && bd.k !== 1) || (k === 0 && bd.k !== 0)) {
        bd.k = k;
        bd.el.style.setProperty('--k', k.toFixed(3));
        if (bd.fx === 'rise') {
          const ks = clamp((k - 0.66) * 4, 0, 1), kb = clamp((k - 0.78) * 5, 0, 1);
          if (ks !== bd.ks) { bd.ks = ks; bd.el.style.setProperty('--ks', ks.toFixed(3)); }
          if (kb !== bd.kb) { bd.kb = kb; bd.el.style.setProperty('--kb', kb.toFixed(3)); }
        }
      }
    }
    // the light band sweeps the still; the watch brightens as it passes
    const sw = Math.round(p * 500) / 500;
    if (sw !== lastSw) { lastSw = sw; sweepHost.style.setProperty('--sw', sw); }
    const lit = Math.round(smoothstep(p, 0.05, 0.85) * 200) / 200;
    if (lit !== lastLit) { lastLit = lit; posterImg.style.setProperty('--lit', lit); }
    const sc = p > 0.015;
    if (sc !== scrolledOn) { scrolledOn = sc; hero.classList.toggle('scrolled', sc); }
  }

  let seekBusy = false, pendingTime = null;
  function requestSeek(t) {
    if (!video.duration || !videoReady) return;
    if (seekBusy) { pendingTime = t; return; }
    seekBusy = true;
    video.currentTime = t;
  }
  if (video) {
    video.addEventListener('seeked', () => {
      seekBusy = false;
      if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); }
    });
    video.addEventListener('error', () => { seekBusy = false; pendingTime = null; failVideo(); });
  }

  function tick(now) {
    const dt = Math.min(100, now - (lastTick || now));
    lastTick = now;
    const k = 0.16;
    shown += (target - shown) * (1 - Math.pow(1 - k, dt / 16.667));
    const settledLoad = loadK >= 1;
    if (Math.abs(target - shown) < 0.0005 && settledLoad) {
      shown = target; rafId = null; lastTick = 0;
    } else {
      rafId = requestAnimationFrame(tick);
    }
    if (videoReady) requestSeek(shown * video.duration);
    updateCaptions(shown, now);
  }

  function onScroll() {
    target = heroProgress();
    if (rafId === null && heroOnScreen && scrubOn) rafId = requestAnimationFrame(tick);
  }

  /* video: streamed Blob behind an honest ring */
  let videoReady = false, heroInited = false;
  function initHeroOnce() {
    if (heroInited) return;
    heroInited = true;
    posterImg.addEventListener('load', () => { posterImg.classList.add('loaded'); startBlobFetch(); }, { once: true });
    posterImg.addEventListener('error', startBlobFetch, { once: true });
    posterImg.src = posterImg.dataset.src;
    setTimeout(startBlobFetch, 4000);
  }
  let started = false;
  function startBlobFetch() {
    if (started) return;
    started = true;
    if (!VIDEO_URL) { stage.classList.add('video-failed'); return; }
    stage.classList.add('loading');
    loadHeroBlob().catch(failVideo);
  }
  async function loadHeroBlob() {
    const ctrl = new AbortController();
    let watchdog = setTimeout(() => ctrl.abort(), 20000);
    const res = await fetch(VIDEO_URL, { priority: 'low', signal: ctrl.signal });
    if (!res.ok || !res.body) throw new Error('video ' + res.status);
    const total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
    const reader = res.body.getReader();
    const chunks = [];
    let got = 0, lastRing = 0;
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      clearTimeout(watchdog);
      watchdog = setTimeout(() => ctrl.abort(), 20000);
      chunks.push(value);
      got += value.length;
      const frac = Math.min(1, got / total);
      const now = performance.now();
      if (now - lastRing > 100 || frac === 1) { lastRing = now; ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
    }
    clearTimeout(watchdog);
    ring.style.setProperty('--ld', 0);
    video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
    video.load();
    video.addEventListener('canplay', () => {
      videoReady = true;
      stage.classList.remove('loading');
      stage.classList.add('video-ready');
      requestSeek(heroProgress() * video.duration);
    }, { once: true });
  }
  function failVideo() {
    videoReady = false;
    stage.classList.remove('loading', 'video-ready');
    stage.classList.add('video-failed');
  }

  /* the five gates, decided live */
  const GATES = [
    '(max-width: 720px)',
    '(orientation: portrait) and (max-width: 1024px)',
    '(orientation: portrait) and (pointer: coarse)',
    '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
    '(prefers-reduced-motion: reduce)'
  ];
  const MQLS = GATES.map(q => matchMedia(q));
  let scrubOn = false;
  function enableScrub() {
    if (scrubOn || !hero) return;
    scrubOn = true;
    initHeroOnce();
    addEventListener('scroll', onScroll, { passive: true });
    bands.forEach(b => { b.op = -1; b.k = -1; b.ks = -1; b.kb = -1; });
    lastSw = -1; lastLit = -1;
    shown = target = heroProgress();
    updateCaptions(shown, performance.now());
    rafId = null;
    onScroll();
    if (rafId === null) rafId = requestAnimationFrame(tick);
  }
  function disableScrub() {
    if (!scrubOn) return;
    scrubOn = false;
    removeEventListener('scroll', onScroll);
    if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
  }
  function applyHeroMode() { MQLS.some(m => m.matches) ? disableScrub() : enableScrub(); }
  MQLS.forEach(m => m.addEventListener('change', applyHeroMode));

  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => {
      heroOnScreen = es[0].isIntersecting;
      if (heroOnScreen) onScroll();
    }).observe(hero);
  }

  /* ---------- nav ---------- */
  const nav = $('.nav');
  let navSolid = null;
  function navState() {
    const s = scrollY > 40;
    if (s !== navSolid) { navSolid = s; nav.classList.toggle('solid', s); }
  }
  addEventListener('scroll', navState, { passive: true });
  navState();

  /* ---------- entrances and living elements ---------- */
  const counters = $$('.num[data-to]');
  let countersDone = false;
  function runCounters() {
    if (countersDone) return;
    countersDone = true;
    if (RM.matches) return;
    const t0 = performance.now();
    counters.forEach(n => (n.textContent = '0'));
    let last = counters.map(() => '0');
    (function step(now) {
      const t = clamp((now - t0) / 1600, 0, 1);
      const e = 1 - Math.pow(1 - t, 4);
      counters.forEach((n, i) => {
        const s = String(Math.round(Number(n.dataset.to) * e));
        if (s !== last[i]) { last[i] = s; n.textContent = s; }
      });
      if (t < 1) requestAnimationFrame(step);
    })(t0);
  }

  if ('IntersectionObserver' in window) {
    const revealIO = new IntersectionObserver(es => {
      es.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        if (e.target.classList.contains('spec-list')) runCounters();
        revealIO.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    $$('.reveal').forEach(el => revealIO.observe(el));
    const liveIO = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('live', e.isIntersecting)));
    $$('main > section:not(.hero)').forEach(s => liveIO.observe(s));
  } else {
    $$('.reveal').forEach(el => el.classList.add('in'));
  }

  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

  /* ---------- the one interactive moment: hold to light the dial ---------- */
  const holder = $('.holder');
  const dial = $('.dial');
  let p = 0, holding = false, hRaf = null, hLast = 0, lastP = -1, lit = false;
  const FILL = 1700, DRAIN = 900;
  function setP(v) {
    const r = Math.round(v * 400) / 400;
    if (r !== lastP) { lastP = r; holder.style.setProperty('--p', r); }
  }
  function hTick(now) {
    const dt = Math.min(64, now - (hLast || now));
    hLast = now;
    if (holding) p = clamp(p + dt / FILL, 0, 1);
    else p = clamp(p - (dt / DRAIN) * (0.35 + p), 0, 1);
    setP(p);
    if (p >= 1 && !lit) {
      lit = true; holding = false;
      holder.classList.add('done');
      dial.classList.add('lit');
    }
    if (lit || (!holding && p <= 0)) { hRaf = null; hLast = 0; return; }
    hRaf = requestAnimationFrame(hTick);
  }
  function hold(on) {
    if (lit) return;
    holding = on;
    if (hRaf === null) hRaf = requestAnimationFrame(hTick);
  }
  if (holder) {
    holder.addEventListener('pointerdown', e => { e.preventDefault(); holder.setPointerCapture && holder.setPointerCapture(e.pointerId); hold(true); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => holder.addEventListener(t, () => hold(false)));
    holder.addEventListener('contextmenu', e => e.preventDefault());
    holder.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); hold(true); } });
    holder.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') hold(false); });
    holder.addEventListener('blur', () => hold(false));
  }

  /* ---------- reduced motion, honored live in both directions ---------- */
  let pinnedLit = false;
  function pinToFinalStates() {
    if (hRaf !== null) { cancelAnimationFrame(hRaf); hRaf = null; }
    if (!lit) { pinnedLit = true; setP(1); dial && dial.classList.add('lit'); }
    counters.forEach(n => (n.textContent = n.dataset.to));
    countersDone = true;
    $$('.reveal').forEach(el => el.classList.add('in'));
  }
  function unpinFinalStates() {
    if (pinnedLit && !lit) { pinnedLit = false; p = 0; setP(0); dial && dial.classList.remove('lit'); }
  }
  RM.addEventListener('change', e => {
    if (e.matches) pinToFinalStates();
    else { unpinFinalStates(); applyHeroMode(); }
  });

  if (RM.matches) pinToFinalStates();
  applyHeroMode();

  /* after a launch-list signup Shopify reloads the page: bring the visitor back to the confirmation */
  if (/customer_posted=true|contact_posted=true/.test(location.search) || $('.form__ok') || $('.form__err')) {
    const n = $('#waitlist');
    if (n) requestAnimationFrame(() => { n.scrollIntoView({ block: 'center' }); const ok = $('.form__ok'); ok && ok.focus({ preventScroll: true }); });
  }
})();
